<div>
  
  <label for="">Titulo
  <input matInput [(ngModel)]="titulo">
  </label>

  <label for="">Autor
    <input matInput [(ngModel)]="autor">
  </label>
  
  <label for="">Foto
  <input type="file" (change)="handleArchivo($event)">
  </label>
  &nbsp;
  <br>
  <button mat-raised-button color="accent" (click)="newImagen()">Subir Imagen</button>
    
    
</div>